// Axios Interceptor para manejar respuestas 401 (Token expirado)
import axios from 'axios';
import tokenExpirationHandler from './tokenExpirationHandler';

// Configurar interceptor de respuesta
const setupAxiosInterceptor = (onTokenExpired) => {
  // Interceptor de respuesta para manejar errores 401
  const responseInterceptor = axios.interceptors.response.use(
    (response) => {
      // Si la respuesta es exitosa, no hacer nada
      return response;
    },
    (error) => {
      // Si es un error 401 (No autorizado)
      if (error.response?.status === 401) {
        console.log('Token expirado detectado por interceptor');
        
        // Limpiar token del localStorage
        localStorage.removeItem('token');
        
        // Detener el monitoreo del token
        tokenExpirationHandler.stopMonitoring();
        
        // Ejecutar callback de token expirado
        if (onTokenExpired) {
          onTokenExpired();
        }
      }
      
      // Re-lanzar el error para que los componentes puedan manejarlo
      return Promise.reject(error);
    }
  );

  // Interceptor de request para agregar token automáticamente
  const requestInterceptor = axios.interceptors.request.use(
    (config) => {
      const token = localStorage.getItem('token');
      if (token) {
        // Asegurar que el token tenga el formato correcto
        const cleanToken = token.startsWith('Bearer ') ? token : `Bearer ${token}`;
        config.headers.Authorization = cleanToken;
      }
      return config;
    },
    (error) => {
      return Promise.reject(error);
    }
  );

  // Función para limpiar interceptors
  const cleanup = () => {
    axios.interceptors.response.eject(responseInterceptor);
    axios.interceptors.request.eject(requestInterceptor);
  };

  return cleanup;
};

export default setupAxiosInterceptor;
